import {
  Box,
  Button,
  Chip,
  CircularProgress,
  Grid,
  IconButton,
  TextField,
  Typography,
} from '@mui/material'
import SimpleModal from 'src/Component/SimpleModal'
import useEditBranchGym from './useEditBranchGym'
import InputField from 'src/Component/InputField'
import { Controller } from 'react-hook-form'
import FileInput from 'src/Component/FileInput'
import editIconRedBg from 'src/assets/icons/editIconRedBg.png'
import SimpleDropdown from 'src/Component/SimpleDropdown'
import { useLazyGetParentGymsListQuery } from 'src/api/parentGymApi'
import { AsyncPaginate } from 'react-select-async-paginate'
import { customStylesForAsyncSelect } from '../AddBranchGymModal'

type EditBranchGymModalProps = {
  id: number
  open: boolean
  onClose: () => void
  successCallback: () => void
  onDeleteClick: (id: number) => void
}
const EditBranchGymModal = ({
  id,
  open,
  onClose,
  successCallback,
  onDeleteClick,
}: EditBranchGymModalProps) => {
  const {
    file,
    handleFileChange,
    control,
    errors,
    onSubmit,
    isLoadingEditBranchGym,
    imageUrl,
    showUploadImage,
    handleShowUploadImage,
  } = useEditBranchGym({
    successCallback,
    id,
  })

  const [fetchParentsGym, { isFetching: isFetchingParentsGymData }] =
    useLazyGetParentGymsListQuery()
  const loadMoreParentData = async (search: any, loadedOptions: any, { page }: any) => {
    try {
      const response = await fetchParentsGym({
        search,
        page,
        pageSize: 20,
      })
      console.log('Load Parent response', response, loadedOptions)
      if (response.isSuccess && response?.data?.results?.length) {
        console.log('suraj')

        return {
          options: response.data.results.map((row) => {
            return {
              value: row.id,
              label: row.name,
            }
          }),
          hasMore: !!response.data.next,
          additional: {
            page: page + 1,
          },
        }
      }
    } catch (error) {
      console.log(error)
    }

    return {
      options: [],
      hasMore: false,
      additional: {
        page: 1,
      },
    }
  }

  return (
    <Box>
      <SimpleModal open={open} onClose={onClose}>
        <form onSubmit={onSubmit}>
          <Box>
            {showUploadImage || !imageUrl ? (
              <FileInput
                type='image'
                title='You can click me to upload files!'
                discription='Support for  image file formats (.png, .jpeg)'
                name='fileuplaod'
                value={file}
                onChange={handleFileChange}
                showPreview
              />
            ) : (
              <Box textAlign='center' position='relative' minHeight='50px'>
                <img
                  src={imageUrl}
                  style={{
                    width: '100%',
                    height: '250px',
                    objectFit: 'cover',
                  }}
                />
                <Box
                  sx={{
                    position: 'absolute',
                    right: 0,
                    bottom: 0,
                  }}
                >
                  {' '}
                  <IconButton onClick={handleShowUploadImage}>
                    <img src={editIconRedBg} />
                  </IconButton>
                </Box>
              </Box>
            )}

            <Grid container mt={3}>
              <Grid xs={2.7}>
                <Typography
                  style={{
                    color: 'white',
                    fontWeight: 'bold',
                    fontSize: '15px',
                  }}
                >
                  Parent Gym <span style={{ color: 'red', fontSize: '12px' }}>*</span>
                </Typography>{' '}
              </Grid>
              <Grid xs={5.3} mb={2}>
                <Controller
                  name='parentGym'
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <>
                      <AsyncPaginate
                        styles={customStylesForAsyncSelect}
                        name={field.name}
                        id={field.name}
                        value={field.value}
                        placeholder='Choose Parent Gym'
                        loadOptions={loadMoreParentData}
                        onChange={field.onChange}
                        additional={{
                          page: 1,
                        }}
                      />
                      {!!errors.parentGym?.value && (
                        <Grid container justifyContent='right'>
                          <Typography variant='subtitle2' color='red' textAlign='right'>
                            {errors.parentGym.value.message}
                          </Typography>
                        </Grid>
                      )}
                    </>
                  )}
                />
              </Grid>
            </Grid>
            <Grid container mt={3}>
              <Grid xs={8} mb={2}>
                <Controller
                  name='name'
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <>
                      <InputField
                        name={field.name}
                        type='text'
                        label='Name'
                        placeholder='Enter Branch Gym name'
                        value={field.value}
                        onChange={field.onChange}
                        // error={!!errors.name}
                        required
                      />
                      {!!errors.name && (
                        <Grid container justifyContent='right'>
                          <Typography variant='subtitle2' color='red' textAlign='right'>
                            {errors.name.message}
                          </Typography>
                        </Grid>
                      )}
                    </>
                  )}
                />
              </Grid>
            </Grid>
            <Grid container mt={3}>
              <Grid xs={8} mb={2}>
                <Controller
                  name='about'
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <>
                      <InputField
                        name={field.name}
                        type='text'
                        label='About'
                        placeholder='Enter BranchGym about'
                        value={field.value}
                        onChange={field.onChange}
                        // error={!!errors.about}
                        required
                        multiline
                        rows={3}
                      />
                      {!!errors.about && (
                        <Grid container justifyContent='right'>
                          <Typography variant='subtitle2' color='red' textAlign='right'>
                            {errors.about.message}
                          </Typography>
                        </Grid>
                      )}
                    </>
                  )}
                />
              </Grid>
            </Grid>
            <Grid container>
              <Grid xs={8} mb={2}>
                <Controller
                  name='address'
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <>
                      <InputField
                        name={field.name}
                        type='text'
                        label='Address'
                        placeholder='Enter park address'
                        value={field.value}
                        onChange={field.onChange}
                        // error={!!errors.address}
                        required
                      />
                      {!!errors.address && (
                        <Grid container justifyContent='right'>
                          <Typography variant='subtitle2' color='red' textAlign='right'>
                            {errors.address.message}
                          </Typography>
                        </Grid>
                      )}
                    </>
                  )}
                />
              </Grid>
            </Grid>

            <Grid container>
              <Grid xs={8} mb={2}>
                <Controller
                  name='latitude'
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <>
                      <InputField
                        name={field.name}
                        type='number'
                        regex={/[^0-9]*$/}
                        label='Latitude'
                        placeholder='Enter park latitude'
                        value={field.value === 0 ? '' : field.value}
                        onChange={field.onChange}
                        // error={!!errors.latitude}
                        required
                      />
                      {!!errors.latitude && (
                        <Grid container justifyContent='right'>
                          <Typography variant='subtitle2' color='red' textAlign='right'>
                            {errors.latitude.type === 'typeError'
                              ? 'Latitude shoule be number'
                              : errors.latitude.message}
                          </Typography>
                        </Grid>
                      )}
                    </>
                  )}
                />
              </Grid>
            </Grid>

            <Grid container>
              <Grid xs={8} mb={2}>
                <Controller
                  name='longitude'
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <>
                      <InputField
                        name={field.name}
                        type='number'
                        regex={/[^0-9]*$/}
                        label='Longitude'
                        placeholder='Enter park longitude'
                        value={field.value === 0 ? '' : field.value}
                        onChange={field.onChange}
                        // error={!!errors.longitude}
                        required
                      />
                      {!!errors.longitude && (
                        <Grid container justifyContent='right'>
                          <Typography variant='subtitle2' color='red' textAlign='right'>
                            {errors.longitude.type === 'typeError'
                              ? 'Longitude shoule be number'
                              : errors.longitude.message}
                          </Typography>
                        </Grid>
                      )}
                    </>
                  )}
                />
              </Grid>
            </Grid>
            <Grid container>
              <Grid xs={8} mb={2}>
                <Controller
                  name='rating'
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <>
                      <InputField
                        name={field.name}
                        type='number'
                        regex={/[^0-9]*$/}
                        label='rating'
                        placeholder='Enter park rating'
                        value={field.value === 0 ? '' : field.value}
                        onChange={field.onChange}
                        // error={!!errors.rating}
                        required
                      />
                      {!!errors.rating && (
                        <Grid container justifyContent='right'>
                          <Typography variant='subtitle2' color='red' textAlign='right'>
                            {errors.rating.type === 'typeError'
                              ? 'rating shoule be number'
                              : errors.rating.message}
                          </Typography>
                        </Grid>
                      )}
                    </>
                  )}
                />
              </Grid>
            </Grid>
            <Grid container>
              <Grid xs={8} mb={2}>
                <Controller
                  name='open'
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <>
                      <InputField
                        name={field.name}
                        type='time'
                        label='Open At'
                        placeholder='Enter the Time'
                        value={field.value}
                        onChange={field.onChange}
                        // error={!!errors.open}
                        required
                      />
                      {!!errors.open && (
                        <Grid container justifyContent='right'>
                          <Typography variant='subtitle2' color='red' textAlign='right'>
                            {errors.open.message}
                          </Typography>
                        </Grid>
                      )}
                    </>
                  )}
                />
              </Grid>
            </Grid>
            <Grid container>
              <Grid xs={8} mb={2}>
                <Controller
                  name='close'
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <>
                      <InputField
                        name={field.name}
                        type='time'
                        label='Close At'
                        placeholder='Enter the Time'
                        value={field.value}
                        onChange={field.onChange}
                        // error={!!errors.close}
                        required
                      />
                      {!!errors.close && (
                        <Grid container justifyContent='right'>
                          <Typography variant='subtitle2' color='red' textAlign='right'>
                            {errors.close.message}
                          </Typography>
                        </Grid>
                      )}
                    </>
                  )}
                />
              </Grid>
            </Grid>

            <Button
              variant='contained'
              color='secondary'
              type='submit'
              disabled={isLoadingEditBranchGym}
            >
              {isLoadingEditBranchGym ? <CircularProgress size={25} color='error' /> : 'SAVE'}
            </Button>
            <Button
              onClick={() => onDeleteClick(id)}
              sx={{ marginLeft: '20px' }}
              variant='contained'
              color='primary'
              type='button'
            >
              DELETE
            </Button>
          </Box>
        </form>
      </SimpleModal>
    </Box>
  )
}

export default EditBranchGymModal
